"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const api_1 = require("../../api");
const formik_1 = require("formik");
const HandScanner_1 = __importDefault(require("../HandScanner"));
const Modal_1 = __importDefault(require("../Modal"));
const NumberInput_1 = __importDefault(require("../../forms/Fields/NumberInput"));
const Button_1 = __importDefault(require("../../forms/Button"));
const handleError_1 = __importDefault(require("../../handleError"));
const errorNotification_1 = require("../../errorNotification");
const Scanner = ({ handleScanUpdate }, ...props) => {
    const [formModalOpened, setFormModalOpened] = (0, react_1.useState)(false);
    const [ean, setEan] = (0, react_1.useState)(null);
    const [current, setCurrent] = (0, react_1.useState)({ quantity: 0 });
    const fillOrderApi = new api_1.OrderFullfillmentApi();
    const onHandScan = async (scancode, handleSubmit, handleFormReset) => {
        setEan(scancode);
        setFormModalOpened(false);
        try {
            const data = await fillOrderApi
                .get(scancode);
            setFormModalOpened(true);
            handleFormReset();
        }
        catch (error) {
            setFormModalOpened(false);
            handleFormReset();
            (0, handleError_1.default)(error);
        }
    };
    const onSubmit = async (values, { setErrors, setSubmitting }) => {
        setSubmitting(true);
        try {
            // @ts-ignore
            const { updates } = await fillOrderApi.update(ean, values);
            handleScanUpdate(updates);
            (0, errorNotification_1.notify)('success', 'Order filled!');
        }
        catch (error) {
            (0, handleError_1.default)(error);
        }
        setSubmitting(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(formik_1.Formik, { initialValues: {
                supplier: null,
                incoming_quantity: 0,
            }, onSubmit: onSubmit, enableReinitialize: true }, ({ isSubmitting, handleSubmit, handleReset }) => (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(HandScanner_1.default, { handleOnScan: (code) => onHandScan(code, handleSubmit, handleReset) }),
            react_1.default.createElement(Modal_1.default, { isOpen: formModalOpened, onRequestClose: () => { setFormModalOpened(false); handleReset(); } },
                react_1.default.createElement(formik_1.Form, { className: "space-y-6 m-4" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("span", { className: 'font-bold' }, "EAN: "),
                        ean),
                    react_1.default.createElement(NumberInput_1.default, { name: 'incoming_quantity', label: 'Menge', min: 0 }),
                    react_1.default.createElement("div", { className: 'flex justify-between pt-4' },
                        react_1.default.createElement(Button_1.default, { type: "button", variant: 'secondary', onClick: () => { setFormModalOpened(false); handleReset(); } }, "Abbrechen"),
                        react_1.default.createElement(Button_1.default, { type: "submit", disabled: isSubmitting, onClick: () => { handleSubmit(); setFormModalOpened(false); } }, "Speichern")))))))));
};
exports.default = Scanner;
